import React from 'react';

export default ({ session }) => {
    const { sessionTags } = session || {};
    if (sessionTags && sessionTags.length > 0) {
        return <div className='margin-top-small'>
            {sessionTags.map((tag) => <div key={tag} className='tag-box'>{tag}</div>)}
        </div>;
    }
    return null;
};
